<template>
  <hcm-card
    :resource="resource"
    :externalResource="false"
    :hasSource="false"
    :hasShare="false"
    :titleLink="false"
    :cardTitle="resource.title"
    :cardText="resource.introText"
  >
    <template v-slot:custom-actions>
      <div class="actions-wrapper">
        <v-btn class="continue-button" to="/news" depressed color="secondary"
          >Continue</v-btn
        >
      </div>
    </template>
  </hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";

export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.actions-wrapper {
  display: flex;
  justify-content: center;
  margin: 20px;
}
</style>
